// namespace
export const BURIAL_NAMESPACE = 'burial'

// getters
export const BURIAL_GETTER = 'burial'

// mutations
export const BURIAL_MUTATION_SINGLE_ENTRY = 'updateBurialFromSingleEntry'
export const BURIAL_MUTATION_ENTIRE_BURIAL = 'updateEntireBurial'

// actions
export const BURIAL_ACTION_GET_BURIAL = 'fetchBurial'
export const BURIAL_ACTION_SAVE_BURIAL = 'saveBurial'



// WEBPACK FOOTER //
// ./src/store/modules/burial-types.js